import React, { useState, useEffect } from "react";
import {
	Col,
	Row,
	Card,
	CardBody,
	Modal,
	ModalBody,
	ModalHeader,
	List,
	CardText,
	Spinner,
	Container,
} from "reactstrap";
import "./styles.scss";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { Link } from "react-router-dom";
import { AvField, AvForm } from "availity-reactstrap-validation";
import AuthService from "services/Website/AuthService";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { authenticate, setCurrencyRed, setNavigate } from "store/Auth/actions";
import { useTranslation } from "react-i18next";
import Navbar from "components/Website/Layouts/Navbar";
import Footer from "../Layouts/Footer";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import HomeService from "services/Website/HomeService";

const AuthCard = (props) => {
	//{ modal, setModal, history, location }
	const { t } = useTranslation();
	const AuthData = useSelector((state) => state.Auth);
	const [loading, setLoading] = useState(false);
	const [auth, setAuth] = useState("login");
	const [showPassword, setShowPassword] = useState(true);
	const [password, setPassword] = useState("");
	const [loginpassword, setLoginPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const [showConformPassword, setShowConformPassword] = useState(true);
	const [showPasswordInfo, setShowPasswordInfo] = useState(true);
	const [phone, setPhone] = useState("");
	const location = useLocation();
	const to = location?.state?.navigateTo || "";
	const dispatch = useDispatch();

	useEffect(() => {
		setShowPassword(true);
	}, [auth]);

	useEffect(() => {
		if (!!location?.state) {
			if (location?.state === "signup") {
				setAuth("register");
			} else {
				setAuth("login");
			}
		}
	}, [location]);

	useEffect(() => {
		if (auth !== "login") {
			setAuth("login");
		}
	}, []);

	const handleValidSubmit = (event, values) => {
		if (auth === "login") {
			setLoading(true);
			Promise.all([
				AuthService.login(values),
				new HomeService().getCurrencies(),
			])
				.then((res) => {
					if (!res[0].access_token) {
						throw new Error("Faild Login");
					} else {
						dispatch(setNavigate(""));
						setLoading(false);
						dispatch(
							authenticate({
								token: res[0].access_token,
								user_name: res[0].user_name,
								userType: "user",
							})
						);
						dispatch(
							setCurrencyRed(
								res[1]?.data?.find(
									(curr) => curr?.currency_code === res[0]?.default_currency
								)
							)
						);
						props?.history.push(to);
					}
				})
				.catch((e) => {
					setLoading(false);
				});
		} else {
			if (values.password !== values.password_confirmation) {
				toast.error("Password Confirmation doesnot match Password");
				return;
			}
			setLoading(true);
			Promise.all([
				AuthService.register({ ...values, phone: phone }),
				new HomeService().getCurrencies(),
			])
				.then((res) => {
					if (res[0].data.access_token) {
						localStorage.setItem("token", res[0].data.access_token);
						localStorage.setItem(
							"auth",
							JSON.stringify({ ...res[0].data, user_type: "user" })
						);
						setLoading(false);
						dispatch(
							authenticate({
								token: res[0].data.access_token,
								user_name: res[0].data.user_name,
								userType: "user",
							})
						);
						dispatch(
							setCurrencyRed(
								res[1]?.data?.find(
									(curr) =>
										curr?.currency_code === res[0]?.data?.default_currency
								)
							)
						);
						props?.history.push(to);
					}
				})
				.catch((error) => {
					toast.error(error?.response?.data?.error);
					// if (error?.response?.data?.error === t("The password format is invalid")) {
					//     setShowPasswordInfo(true)
					// }
					setLoading(false);
				});
		}
	};
	return (
		<div className="websitPages">
			<Navbar />
			<Container>
				<Row className="justify-content-center pt-10rem pb-5">
					<Col lg="7">
						<Card
							className="overflow-hidden box-shadow mt-5 br-40"
							style={{ direction: "inherit" }}>
							<CardBody className="m-0 websitPages">
								<Row className="justify-content-center">
									{auth === "login" && (
										<Col md={12}>
											<div className="text-center">
												<CardText
													tag="h3"
													className="p-0 font-size-32 text-center mt-4 bask-font text-primary fs-italic fw-bold">
													{t("sign in")}
												</CardText>
												{/* <div className="pt-2">
													<span
														className=" font-size-14 p-0 m-0"
														style={{ opacity: 5 }}>
														{t("sign subtitle")}
													</span>
												</div> */}
											</div>
										</Col>
									)}
									<Col lg="10">
										{auth === "login" && (
											<AvForm
												className="form-horizontal custom-form formWithLabel pt-3"
												onValidSubmit={(e, v) => {
													handleValidSubmit(e, v);
												}}>
												<div className="mt-4 position-relative">
													<p className="text-primary label my-1">
														{t("Email")}
													</p>
													<AvField
														name="email"
														className="form-control mb-3 py-3 px-5rem rounded-pill"
														// placeholder={t("email // placeholder")}
														type="email"
														id={"email"}
														required
														// readonly
														// onFocus={() => document.getElementById("email").removeAttribute('readonly')}
													/>
												</div>
												<div className="mt-2 mb-3 position-relative">
													<p className="text-primary label my-1">
														{t("Password")}
													</p>
													<AvField
														name="password"
														type={showPassword ? "password" : "text"}
														required
														onChange={(e) => setLoginPassword(e.target.value)}
														// placeholder={t("password placeolder")}
														className="rounded-pill px-7rem py-3"
														id={"password"}
														// onFocus={() => document.getElementById("password").removeAttribute('readonly')}
													/>
													<div
														className={`${
															AuthData.lang !== "ar"
																? "absolute-eye-en"
																: "absolute-eye-ar"
														}`}
														onClick={() => setShowPassword(!showPassword)}>
														{loginpassword.trim().length !== 0 ? (
															showPassword ? (
																<i className="fas fa-eye-slash"></i>
															) : (
																<i className="fas fa-eye  "></i>
															)
														) : null}
													</div>
												</div>
												<div className="mt-4  forget-link d-flex flex-row-reverse  ">
													<Link
														to={`/forget-password`}
														style={{ color: "#FA4C1F" }}>
														{t("Forgot Password")}
													</Link>
												</div>
												<div className="mt-4 d-flex justify-content-between">
													<button
														type="button"
														className="btn text-primary"
														onClick={() => {
															setAuth("register");
														}}>
														{t("Don’t Have Account?")}{" "}
														<span className="fw-bold">{t("sign up")}</span>
														{/* <span className="text-primary">
														</span>
														<span className="fw-bold px-2 newTextPrimary">
														</span> */}
													</button>
													{loading ? (
														<div className="m-auto btnHeight">
															<Spinner color="primary" />
														</div>
													) : (
														<button
															className="btn fw-bold btnOrange btnHeight px-5 text-center"
															type="submit">
															{t("LogIn")}
														</button>
													)}
												</div>
											</AvForm>
										)}
										{auth === "register" && (
											<Col md={12}>
												<div className="text-center">
													<CardText
														tag="h3"
														className="p-0 m-0 text-center mt-4 bask-font font-size-32 text-primary fs-italic fw-bold">
														{t("Sign Up")}
													</CardText>
													{/* <div className="pt-2">
														<span
															className=" font-size-14 p-0 m-0"
															style={{ opacity: 5 }}>
															{t("Enter the data below to get your account")}
														</span>
													</div> */}
												</div>
											</Col>
										)}
										{auth === "register" && (
											<AvForm
												className="form-horizontal custom-form formWithLabel pt-5"
												onValidSubmit={(e, v) => {
													handleValidSubmit(e, v);
												}}>
												<Row>
													<Col md={6}>
														<p className="text-primary label my-1">
															{t("First Name")}
														</p>
														<AvField
															name="first_name"
															className="form-control mb-3 py-3 px-6rem rounded-pill"
															// placeholder={t("First Name")}
															type="text"
															required
														/>
													</Col>
													<Col md={6}>
														<p className="text-primary label my-1">
															{t("Last Name")}
														</p>
														<AvField
															name="last_name"
															className="form-control mb-3 py-3 px-6rem rounded-pill"
															// placeholder={t("Last Name")}
															type="text"
															required
														/>
													</Col>
													<Col md={12}>
														<p className="text-primary label my-1">
															{t("Username")}
														</p>
														<AvField
															name="user_name"
															id={"user_name"}
															className="form-control mb-3 rounded-pill py-3 px-6rem"
															// placeholder={t("Username")}
															type="text"
															required
															readOnly
															onFocus={() =>
																document
																	.getElementById("user_name")
																	.removeAttribute("readonly")
															}
														/>
													</Col>
													<Col md={12}>
														<p className="text-primary label my-1">
															{t("Email")}
														</p>
														<AvField
															name="email"
															className="form-control mb-3 rounded-pill py-3 px-4rem"
															// placeholder={t("email // placeholder")}
															type="email"
															required
														/>
													</Col>
													<Col md={12} className="mb-3 signup-number">
														{/* <AvField
                                                        name='phone'
                                                        className='form-control mb-3 rounded-pill px-3'
                                                        // placeholder='+123456789'
                                                        required
                                                    /> */}
														<label className="text-primary label my-1">
															{t("Mobile Number")}
														</label>
														<PhoneInput
															country={"eg"}
															enableSearch={true}
															name="phone"
															className="rounded-pil phone py-3"
															value={phone}
															onChange={(e) => setPhone(e)}
														/>
													</Col>
													<Col md={12}>
														<p className="text-primary label my-1">
															{t("Password")}
														</p>
														<AvField
															name="password"
															type={showPassword ? "password" : "text"}
															className="form-control mb-3 rounded-pill py-3 px-6rem"
															// placeholder={t("password placeolder")}
															onChange={(e) => setPassword(e.target.value)}
															required
															readOnly
															onFocus={() =>
																document
																	.getElementById("password")
																	.removeAttribute("readonly")
															}
														/>
														<div
															style={{
																position: "absolute",
																top: "40px",
																right:
																	AuthData.lang !== "ar" ? "20px" : "unset",
																left: AuthData.lang !== "ar" ? "unset" : "20px",
															}}
															onClick={() => setShowPassword(!showPassword)}>
															{password.trim().length !== 0 ? (
																showPassword ? (
																	<i className="fas fa-eye-slash"></i>
																) : (
																	<i className="fas fa-eye  "></i>
																)
															) : null}
														</div>
													</Col>
													<Col md={12}>
														<p className="text-primary label my-1">
															{t("Re-Type Password")}
														</p>
														<AvField
															onChange={(e) =>
																setConfirmPassword(e.target.value)
															}
															name="password_confirmation"
															type={showConformPassword ? "password" : "text"}
															className="form-control mb-3 rounded-pill py-3 px-9rem"
															required
															// placeholder={t("Re-Type Password")}
														/>
														<div
															style={{
																position: "absolute",
																top: "40px",
																right:
																	AuthData.lang !== "ar" ? "20px" : "unset",
																left: AuthData.lang !== "ar" ? "unset" : "20px",
															}}
															onClick={() =>
																setShowConformPassword(!showConformPassword)
															}>
															{confirmPassword.trim().length !== 0 ? (
																showConformPassword ? (
																	<i className="fas fa-eye-slash"></i>
																) : (
																	<i className="fas fa-eye  "></i>
																)
															) : null}
														</div>
													</Col>
												</Row>
												{showPasswordInfo && (
													<Row>
														<List>
															<ul
																style={{ listStyle: "none" }}
																className="px-2 mt-4">
																<li className="text-primary font-size-11">
																	{t("pass error msg 1")}
																</li>
																<li className="text-primary font-size-11">
																	{t("pass error msg 2")}
																</li>
																<li className="text-primary font-size-11">
																	{t("pass error msg 3")}
																</li>
																<li className="text-primary font-size-11">
																	{t("pass error msg 4")}
																</li>
																<li className="text-primary font-size-11">
																	{t("pass error msg 5")}
																</li>
															</ul>
														</List>
													</Row>
												)}
												<div className="mt-4 d-flex justify-content-between">
													<button
														type="button"
														className="btn text-primary"
														onClick={() => {
															setAuth("login");
														}}>
														{t("Already Have Account?")}{" "}
														<span className="fw-bold">{t("sign in")}</span>
														{/* <span className="text-primary">
													</span>
													<span className="fw-bold newTextPrimary px-2">
													</span> */}
													</button>
													{loading ? (
														<div className="m-auto btnHeight">
															<Spinner color="primary"></Spinner>
														</div>
													) : (
														<button
															className="btn btnOrange fw-bold px-5 btnHeight w-100 text-center"
															type="submit">
															{t("sign up")}
														</button>
													)}
												</div>
											</AvForm>
										)}
									</Col>
								</Row>
							</CardBody>
						</Card>
					</Col>
				</Row>
			</Container>
			<Footer />
		</div>
	);
};
export default AuthCard;
